/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser'
import { appConfig } from './app/app.config'
import { AppComponent } from './app/app.component'
import 'iconify-icon'
import { EnvironmentInjector } from '@angular/core'
import { initializePermissions } from './app/core/helpers/permission.initializer'

async function main() {
  const appRef = await bootstrapApplication(AppComponent, appConfig);
  const injector: EnvironmentInjector = appRef.injector;

  await initializePermissions(injector); // ⬅️ Ensure this runs before app logic
}

main().catch((err) => console.error(err));
